import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import * as R from 'ramda'
import moment from 'moment'
import { attachments } from './entities'
import { db, makePropSelector, doc, props, currentUser } from './common'

export let attachmentsByObjectID = createSelector(attachments, R.groupBy(R.prop('objectID')))
export let attachmentsBuffer = state => state.attachments
export let objectAttachments = createSelector(
	[attachmentsByObjectID, attachmentsBuffer, makePropSelector('objectID')]
  , (attachmentsByObjectID, attachmentsBuffer, objectID) => {
  		let a = attachmentsByObjectID[objectID] || []
  		let b = R.values(R.filter(x => x.objectID === objectID, attachmentsBuffer))
  		if (b.length > 0) {
  			a = a.concat(b)
  		}
  		return a
	}
  , 'objectAttachments'
)

// TODO check currentUserAvatar
export let currentUserAvatar = createSelector(
	[currentUser, attachments],
	(userID, attachments) =>
	R.filter(attach => attach.objectID == userID, attachments)[0])

export let avatar = createSelector(
	[attachmentsByObjectID, props]
  , (attachmentsByObjectID, personID) => (attachmentsByObjectID[personID] || [])[0]
)
// TODO: replace 4 next selectors with `avatar`
export let managerAvatar = createSelector(
	[doc, attachmentsByObjectID]
  , (doc, attachmentsByObjectID) => (attachmentsByObjectID[doc._id] || [])[0]
)
export let commentManagerAvatar = createSelector(
	[doc, attachmentsByObjectID]
  , (doc, attachmentsByObjectID) => (attachmentsByObjectID[doc.userID] || [])[0]
)
export let notificationAvatarTo = createSelector(
	[doc, attachmentsByObjectID]
  , (doc, attachmentsByObjectID) => (attachmentsByObjectID[doc.to] || [])[0]
)
export let notificationAvatarFrom = createSelector(
	[doc, attachmentsByObjectID]
  , (doc, attachmentsByObjectID) => (attachmentsByObjectID[doc.from] || [])[0]
)

var property = (state, property) => 'properties/' + (property ? property.alias : 'All')
var project = (state, project) => property(state, doc(state, project.propertyID)) + '/projects/' + moment(project.date).format('YYYY-MM-DD') + ' ' + project.title.replace(/\//g, ' ')
var task = (state, task) => project(state, doc(state, task.projectID)) + '/' + task.taskContent.replace(/\//g, ' ')
var transaction = (state, transaction) => property(state, doc(state, transaction.propertyID)) + '/transactions/' + transaction.dueDate + ' ' + transaction.type.split('/')[1] + ' ' + transaction.amount
var lease = (state, lease) => property(state, doc(state, lease.property)) + '/leases/' + lease.end
var term = (state, lease) => property(state, doc(state, lease.property)) + '/leases/' + lease.end
var owner = (state, owner) => 'owners/' + ((owner && owner.firstName) ? owner.firstName : 'Unknown')
var tenant = (state, tenant) => 'tenants/' + ((tenant && tenant.firstName) ? (tenant.firstName + ' ' + tenant.lastName) : 'Unknown')
var newTenant = (state, tenant) => 'tenants/' + ((tenant && tenant.primaryResident.firstName) ? (tenant.primaryResident.firstName + ' ' + tenant.primaryResident.lastName) : 'Unknown')
var vendor = (state, vendor) => 'vendors/' + ((vendor && vendor.firstName) ? vendor.firstName : 'Unknown')
var manager = (state, manager) => 'managers/' + manager.name
var template = (state, template) => 'templates/'
var listing = (state, listing) => 'listings/'

export let attachmentPath = (state, id) => {
	let obj = doc(state, id)
	if (!obj) return
	return {
		property: property
	  , project: project
	  , 'transaction/bill': transaction
	  , 'transaction/invoice': transaction
	  , 'transaction/invoice-payment': transaction
	  , 'transaction/credit': transaction
	  , 'transaction/refund': transaction
	  , 'transaction/deposit-use': transaction
	  , 'transaction/deposit-refund': transaction
	  , 'transaction/bad-debt': transaction
	  , task: task
	  , lease: lease
	  , owner : owner
	  , tenant: tenant
	  , application: newTenant
	  , agent: vendor
	  , repairman: vendor
	  , merchant: vendor
	  , manager: manager
	  , template: template
	  , listing: listing
	  , term: term
	}[obj.type](state, obj)
}



// WEBPACK FOOTER //
// ./src/selectors/attachments.js